import { AxiosResponse } from "axios";
import { IViaCep } from "../../types/viaCep";
import { ApiViaCep } from "../../Apis/ViaCepApi";

export class ViaCep {
  static async get(cep: string): Promise<AxiosResponse<IViaCep>> {
    return ApiViaCep.get(`/${cep}/json`);
  }
}
